"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var front_exports = {};
__export(front_exports, {
  FrontStorage: () => FrontStorage
});
module.exports = __toCommonJS(front_exports);
var import_core = require("@hcengineering/core");
var import_upload = require("../upload");
const getPathname = /* @__PURE__ */ __name((url) => {
  const base = window?.location?.href !== void 0 ? window.location.href : "http://localhost";
  return new URL(url, base).pathname;
}, "getPathname");
const MULTIPART_MIN_SIZE = 64 * 1024 * 1024;
const MULTIPART_PART_SIZE = 32 * 1024 * 1024;
const MULTIPART_RETRY_TIMEOUT = 30 * 60 * 1e3;
class FrontStorage {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }
  static {
    __name(this, "FrontStorage");
  }
  getFileUrl(workspace, file, filename) {
    const path = `/${workspace}/${filename ?? file}?file=${file}&workspace=${workspace}`;
    return (0, import_core.concatLink)(this.baseUrl, path);
  }
  getCookiePath(workspace) {
    const url = (0, import_core.concatLink)(this.baseUrl, `/${workspace}`);
    return getPathname(url);
  }
  async getFileMeta(token, workspace, file) {
    return {};
  }
  async deleteFile(token, workspace, file) {
    const url = this.getFileUrl(workspace, file);
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to delete file");
    }
  }
  async uploadFile(token, workspace, uuid, file, options) {
    if (file.size > MULTIPART_MIN_SIZE) {
      const base = typeof window !== "undefined" ? window.location.href : "http://localhost";
      const url = new URL(
        (0, import_core.concatLink)(this.baseUrl, `/${workspace}/multipart/${encodeURIComponent(uuid)}`),
        base
      ).toString();
      const headers = {
        Authorization: `Bearer ${token}`,
        "X-Upload-Size": `${file.size}`
      };
      if (options?.space !== void 0) {
        headers["X-Upload-Space"] = options.space;
      }
      await (0, import_upload.uploadMultipart)(
        {
          url,
          headers,
          body: file,
          partSize: MULTIPART_PART_SIZE,
          retryTimeout: MULTIPART_RETRY_TIMEOUT,
          resumeKey: `${workspace}/${uuid}`
        },
        options
      );
      return;
    }
    const formData = new FormData();
    formData.append("file", file, uuid);
    const query = options?.space !== void 0 ? `?space=${encodeURIComponent(options.space)}` : "";
    await (0, import_upload.uploadXhr)(
      {
        url: (0, import_core.concatLink)(this.baseUrl, `/${workspace}${query}`),
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      },
      options
    );
  }
}
//# sourceMappingURL=front.js.map
